import File from "../atoms/inputs/File";

export default function UploadForm() {
  return (
    <form>
      <File />
    </form>
  )
}